import { render, staticRenderFns } from "./PostListPlannedSelectedFacilities.vue?vue&type=template&id=a61dc130&scoped=true&"
import script from "./PostListPlannedSelectedFacilities.vue?vue&type=script&lang=js&"
export * from "./PostListPlannedSelectedFacilities.vue?vue&type=script&lang=js&"
import style0 from "./PostListPlannedSelectedFacilities.vue?vue&type=style&index=0&id=a61dc130&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a61dc130",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VIcon,VTooltip})
